import { useEffect, useRef } from "react"
import { UseFormSetValue } from "react-hook-form"

/**
 * Custom hook that resets dependent form fields when a parent field changes,
 * but skips the reset on initial mount to preserve pre-populated values.
 */
export function useResetDependentFieldsOnChange<T>(
  watchedValue: T,
  setValue: UseFormSetValue<any>,
  resetActions: () => void
) {
  const initialValueRef = useRef(watchedValue)
  const hasInitialized = useRef(false)
  const resetActionsRef = useRef(resetActions)

  useEffect(() => {
    resetActionsRef.current = resetActions
  })

  useEffect(() => {
    if (!hasInitialized.current) {
      hasInitialized.current = true
      initialValueRef.current = watchedValue
      return
    }

    if (watchedValue !== initialValueRef.current) {
      resetActionsRef.current()
      initialValueRef.current = watchedValue
    }
  }, [watchedValue, setValue])
}
